{
  "de": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Veröffentlicht für Kunden & Partner",
        "publishedCustomer": "Veröffentlicht für Kunden",
        "publishedPartners": "Veröffentlicht für Partner",
        "notPublished": "Nicht veröffentlicht"
      },
      "publish_mode": {
        "inherit": "Vorlage folgen",
        "inherit_info": "Behält den veröffentlichten oder unveröffentlichten Status jedes Elements aus der Vorlage bei",
        "publish": "Für Kunden veröffentlichen",
        "publish_info": "Kunden können diese sofort sehen",
        "title": "Veröffentlichung",
        "unpublished": "Ohne Veröffentlichung erstellen",
        "unpublished_info": "Für Kunden verborgen, bis Sie sie veröffentlichen"
      }
    }
  }
}
